import { IconButton, PlusIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type SmsSenderListHeaderProps = {
  onRegister: () => void;
  isRegisterDisabled?: boolean;
};

export const SmsSenderListHeader: FC<SmsSenderListHeaderProps> = ({ onRegister, isRegisterDisabled }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between'>
      <div className='space-y-1'>
        <h2 className='text-4xl font-semibold tracking-tight text-slate-900'>{t('smsWorkspace.senders.listTitle')}</h2>
        <p className='text-secondary-600 max-w-3xl text-sm'>{t('smsWorkspace.senders.listDescription')}</p>
      </div>
      <IconButton
        leadingIcon={<PlusIcon className='size-5 text-white-100' />}
        className='inline-flex w-full max-w-[211px] justify-center capitalize'
        onClick={onRegister}
        disabled={isRegisterDisabled}
        text={t('smsWorkspace.senders.registerButton')}
      />
    </div>
  );
};
